import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
// import Loader from "../casino/components/Loader";
import {
  casinoPL,
  cricketBookMakerPL,
  cricketFancyPL,
  cricketMatchOddsPL,
} from "../utils/profitLoss";
import {
  getAllMatchesOddsCricketAPI,
  getCricketEventDetailsAPI,
  getCricketOddsByMatchIdAPI,
  getMatchDetailsCricketAPI,
  getMyBetsCricketAPI,
  placeCricketBetAPI,
  placeFancyCricketBetAPI,
} from "../service/cricket";
import { toast } from "react-hot-toast";
import {
  applyFancyFor,
  DEFAULT_BET_AMOUNT,
  getProfit,
} from "../utils/constants";
import { getLiveStreamingUrlAPI } from "../service/AuthService";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
export default function CricketGame() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [gameOdds, setGameOdds] = useState({});
  const [gameEvent, setGameEvent] = useState([]);
  const [betPayload, setBetPayload] = useState(null);
  const [cricketMatches, setCricketMatches] = useState([]);
  const [eventExposureAndSettings, setEventExposureAndSettings] = useState({});
  const [userBets, setUserBets] = useState([]);
  const [isPlacingBet, setIsPlacingBet] = useState(false)
  const [selectedFancy, setSelectedFancy] = useState("Normal");
  const [showLadderForMarket, setShowLadderForMarket] = useState();
  const [isTvOpen, setIsTvOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("odds");
  const userData = useSelector((state) => state.account.userData);
  const elementRef = useRef(null);
  const getGameEventDetails = useCallback(async () => {
    const { response, code } = await getCricketEventDetailsAPI(id);
    if (code === 200) {
      setGameEvent(response);
    }
  }, [id]);

  // const handleBetPlace = () => {
  //   setLoading(true);

  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 3000); 
  // };

  const getCricketOddsByMatchId = useCallback(async () => {
    const { response, code } = await getCricketOddsByMatchIdAPI(id);
    if (code === 200) {
      setGameOdds(response);
    }
  }, [id]);
  const naviagte = useNavigate();
  const getCricketMatches = async () => {
    const { response, code } = await getAllMatchesOddsCricketAPI();
    console.log("getCricketMatches", response);
    if (code == 200) {
      response.map((item) => {
        return item;
      });
      setCricketMatches(response);
    }
  };
  useEffect(() => {
    let interval;

    getCricketMatches();

    interval = setInterval(() => {
      getCricketMatches();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  const navigateToGame = (gameEvent) => {
    window.open(`/game/cricket/${gameEvent["cricketId"]}`);
  };
  const getEventExposureAndSettings = useCallback(async () => {
    const { response, code } = await getMatchDetailsCricketAPI(id);
    if (code === 200) {
      setEventExposureAndSettings(response);
    }
  }, [id]);
  const applyBlinkEffect = (element) => {
    element.classList.add("blink");

    setTimeout(() => {
      element.classList.remove("blink");
    }, 1000);
  };
  const dispatch = useDispatch();
  const setSelectedEventForBet = (data, isCashout = false) => {
    if (data.isBookmaker) {
      dispatch({
        type: "gameData/setSelectedEventForBet",
        payload: {
          ...data,
          eventId: id,
          amount: isCashout ? data.amount : 0,
          profit: getProfit(0, game, data).profit,
          loss: getProfit(0, game, data).loss,
        },
      });
    } else {
      dispatch({
        type: "gameData/setSelectedEventForBet",
        payload: {
          ...data,
          eventId: id,
          amount: isCashout ? data.amount : 0,
          profit: getProfit(0, game, data).profit,
          loss: getProfit(0, game, data).loss,
        },
      });
    }
  };

  const game = "cricket";
  const handleCashoutClick = (
    marketIdExternal,
    marketType = "matchOdds",
    sports = "cricket"
  ) => {
    const plExposures = [];

    for (
      let i = 0;
      i < eventExposureAndSettings?.plExposureResponseDTOs.length;
      i++
    ) {
      if (
        eventExposureAndSettings?.plExposureResponseDTOs[i].marketIdExternal ===
        marketIdExternal
      ) {
        for (
          let j = 0;
          j <
          eventExposureAndSettings?.plExposureResponseDTOs[i]
            .runnerPlExposureDTOS.length;
          j++
        ) {
          plExposures.push(
            eventExposureAndSettings?.plExposureResponseDTOs[i]
              .runnerPlExposureDTOS[j]
          );
        }
      }
    }

    plExposures.sort((a, b) => b.exposure - a.exposure);

    var odds = [];
    if (sports == "cricket") {
      for (let i = 0; i < gameOdds[marketType][0]?.oddDetailsDTOS.length; i++) {
        if (
          plExposures.find(
            (item) =>
              item.selectionId ==
              gameOdds[marketType][0]?.oddDetailsDTOS[i]?.selectionId
          )
        ) {
          odds.push({
            ...gameOdds[marketType][0]?.oddDetailsDTOS[i],
            exposure: plExposures.find(
              (item) =>
                item.selectionId ==
                gameOdds[marketType][0]?.oddDetailsDTOS[i].selectionId
            ).exposure,
          });
        }
      }
    } else {
      for (
        let i = 0;
        i < gameOdds?.matchOddsResponseDTO[0]?.oddDetailsDTOS.length;
        i++
      ) {
        if (
          plExposures.find(
            (item) =>
              item.selectionId ==
              gameOdds?.matchOddsResponseDTO[0]?.oddDetailsDTOS[i].selectionId
          )
        ) {
          odds.push({
            ...gameOdds?.matchOddsResponseDTO[0]?.oddDetailsDTOS[i],
            exposure: plExposures.find(
              (item) =>
                item.selectionId ==
                gameOdds?.matchOddsResponseDTO[0]?.oddDetailsDTOS[i].selectionId
            ).exposure,
          });
        }
      }
    }
    odds.sort((a, b) => b.exposure - a.exposure);
    var oppositeTeam = {
      back1: parseFloat(odds[1]?.back1),
      back2: parseFloat(odds[1]?.back2),
      back3: parseFloat(odds[1]?.back3),
      backSize1: parseFloat(odds[1]?.backSize1),
      backSize2: parseFloat(odds[1]?.backSize2),
      backSize3: parseFloat(odds[1]?.backSize3),
      lay1: parseFloat(odds[1]?.lay1),
      lay2: parseFloat(odds[1]?.lay2),
      lay3: parseFloat(odds[1]?.lay3),
      laySize1: parseFloat(odds[1]?.laySize1),
      laySize2: parseFloat(odds[1]?.laySize2),
      laySize3: parseFloat(odds[1]?.laySize3),
      exposure: odds[1]?.exposure,
      runnerName: odds[1]?.runnerName,
    };
    var sameTeam = {
      back1: parseFloat(odds[0]?.back1),
      back2: parseFloat(odds[0]?.back2),
      back3: parseFloat(odds[0]?.back3),
      backSize1: parseFloat(odds[0]?.backSize1),
      backSize2: parseFloat(odds[0]?.backSize2),
      backSize3: parseFloat(odds[0]?.backSize3),
      lay1: parseFloat(odds[0]?.lay1),
      lay2: parseFloat(odds[0]?.lay2),
      lay3: parseFloat(odds[0]?.lay3),
      laySize1: parseFloat(odds[0]?.laySize1),
      laySize2: parseFloat(odds[0]?.laySize2),
      laySize3: parseFloat(odds[0]?.laySize3),
      exposure: odds[0]?.exposure,
      runnerName: odds[0]?.runnerName,
    };
    var calculationMap = {
      pandl: -Infinity,
      amount: 0,
      oddDecided: 0,
      type: "back",
      oddRate: 0,
    };
    function calculatePandL(oddType, OddSize) {
      if (oddType == "back1" || oddType == "back2" || oddType == "back3") {
        var pandlInternal =
          (oppositeTeam.exposure +
            oppositeTeam[oddType] * sameTeam.exposure -
            sameTeam.exposure) /
          oppositeTeam.oddType;
        var amountInternal = sameTeam.exposure - pandlInternal;
        if (calculationMap.pandl < pandlInternal && amountInternal > 0) {
          calculationMap.pandl = pandlInternal;
          calculationMap.amount = amountInternal;
          calculationMap.oddDecided = oppositeTeam[oddType];
          calculationMap.type = "back";
          calculationMap.oddRate = oppositeTeam[OddSize];
          calculationMap.runnerName = sameTeam.runnerName;
        }
      } else {
        var pandlInternal =
          (sameTeam.exposure +
            sameTeam[oddType] * oppositeTeam.exposure -
            oppositeTeam.exposure) /
          sameTeam[oddType];
        var amountInternal = pandlInternal - oppositeTeam.exposure;
        if (calculationMap.pandl < pandlInternal && amountInternal > 0) {
          calculationMap.pandl = pandlInternal;
          calculationMap.amount = amountInternal;
          calculationMap.oddDecided = sameTeam[oddType];
          calculationMap.type = "lay";
          calculationMap.oddRate = sameTeam[OddSize];
          calculationMap.runnerName = sameTeam.runnerName;
        }
      }
    }
    calculatePandL("back1", "backSize1");
    calculatePandL("back2", "backSize2");
    calculatePandL("back3", "backSize3");
    calculatePandL("lay1", "laySize1");
    calculatePandL("lay2", "laySize2");
    calculatePandL("lay3", "laySize3");

    if (calculationMap.pandl == -Infinity) {
      toast.error(" You are not eligible for cashout");
      return;
    }
    const cashOutPayload = {
      selectedOdd: calculationMap.oddDecided,
      selectedRate: calculationMap.oddRate,
      amount: parseFloat(calculationMap.amount).toFixed(2),
      isBookmaker: false,
      eventId: id,
      marketId: marketIdExternal,
      runnerName: calculationMap.runnerName,
      selectionId: odds[0]?.selectionId,
      marketName:
        game == "cricket"
          ? gameOdds?.matchOdds[0]?.marketName
          : gameOdds?.matchOddsResponseDTO[0]?.marketName,
      gameType:
        game == "cricket"
          ? gameOdds?.matchOdds[0]?.marketName
          : gameOdds?.matchOddsResponseDTO[0]?.marketName,
      marketType,
      sports,
      isCashout: true,
      type: calculationMap.type,
      odd: calculationMap.oddDecided,
    };

    if (cashOutPayload.type === "lay") {
      cashOutPayload.lay = cashOutPayload.odd;
    } else {
      cashOutPayload.back = cashOutPayload.odd;
    }
    cashOutPayload.profit = getProfit(
      calculationMap.amount,
      game,
      cashOutPayload
    ).profit;

    cashOutPayload.loss = getProfit(
      calculationMap.amount,
      game,
      cashOutPayload
    ).loss;

    setBetPayload(cashOutPayload);
    setSelectedEventForBet(
      {
        selectedOdd: calculationMap.oddDecided,
        selectedRate: calculationMap.oddRate,
        amount: parseFloat(calculationMap.amount).toFixed(2),
        isBookmaker: false,
        eventId: id,
        marketId: marketIdExternal,
        runnerName: calculationMap.runnerName,
        selectedId: odds[0]?.selectionId,
        marketName:
          game == "cricket"
            ? gameOdds?.matchOdds[0]?.marketName
            : gameOdds?.matchOddsResponseDTO[0]?.marketName,
        marketType,
        sports,
        isCashout: true,
        type: calculationMap.type,
      },
      true
    );
  };

  const handleBookCashoutClick = (
    marketIdExternal,
    marketType = "bookMaker",
    sports = "cricket"
  ) => {
    const plExposures = [];

    for (
      let i = 0;
      i < eventExposureAndSettings?.plExposureResponseDTOs.length;
      i++
    ) {
      if (
        eventExposureAndSettings?.plExposureResponseDTOs[i].marketIdExternal ===
        marketIdExternal
      ) {
        for (
          let j = 0;
          j <
          eventExposureAndSettings?.plExposureResponseDTOs[i]
            .runnerPlExposureDTOS.length;
          j++
        ) {
          plExposures.push(
            eventExposureAndSettings?.plExposureResponseDTOs[i]
              .runnerPlExposureDTOS[j]
          );
        }
      }
    }

    plExposures.sort((a, b) => b.exposure - a.exposure);

    var odds = [];
    if (sports == "cricket") {
      for (
        let i = 0;
        i < gameOdds[marketType][0]?.bm1?.oddDetailsDTOS.length;
        i++
      ) {
        if (
          plExposures.find(
            (item) =>
              item.selectionId ==
              gameOdds[marketType][0]?.bm1?.oddDetailsDTOS[i]?.selectionId
          )
        ) {
          odds.push({
            ...gameOdds[marketType][0]?.bm1?.oddDetailsDTOS[i],
            exposure: plExposures.find(
              (item) =>
                item.selectionId ==
                gameOdds[marketType][0]?.bm1?.oddDetailsDTOS[i].selectionId
            ).exposure,
          });
        }
      }
    } else {
      for (
        let i = 0;
        i < gameOdds?.matchOddsResponseDTO[0]?.oddDetailsDTOS.length;
        i++
      ) {
        if (
          plExposures.find(
            (item) =>
              item.selectionId ==
              gameOdds?.matchOddsResponseDTO[0]?.oddDetailsDTOS[i].selectionId
          )
        ) {
          odds.push({
            ...gameOdds?.matchOddsResponseDTO[0]?.oddDetailsDTOS[i],
            exposure: plExposures.find(
              (item) =>
                item.selectionId ==
                gameOdds?.matchOddsResponseDTO[0]?.oddDetailsDTOS[i].selectionId
            ).exposure,
          });
        }
      }
    }
    odds.sort((a, b) => b.exposure - a.exposure);
    var oppositeTeam = {
      back1: parseFloat(odds[1]?.back1),
      back2: parseFloat(odds[1]?.back2),
      back3: parseFloat(odds[1]?.back3),
      backSize1: parseFloat(odds[1]?.backSize1),
      backSize2: parseFloat(odds[1]?.backSize2),
      backSize3: parseFloat(odds[1]?.backSize3),
      lay1: parseFloat(odds[1]?.lay1),
      lay2: parseFloat(odds[1]?.lay2),
      lay3: parseFloat(odds[1]?.lay3),
      laySize1: parseFloat(odds[1]?.laySize1),
      laySize2: parseFloat(odds[1]?.laySize2),
      laySize3: parseFloat(odds[1]?.laySize3),
      exposure: odds[1]?.exposure,
      runnerName: odds[1]?.runnerName,
    };
    var sameTeam = {
      back1: parseFloat(odds[0]?.back1),
      back2: parseFloat(odds[0]?.back2),
      back3: parseFloat(odds[0]?.back3),
      backSize1: parseFloat(odds[0]?.backSize1),
      backSize2: parseFloat(odds[0]?.backSize2),
      backSize3: parseFloat(odds[0]?.backSize3),
      lay1: parseFloat(odds[0]?.lay1),
      lay2: parseFloat(odds[0]?.lay2),
      lay3: parseFloat(odds[0]?.lay3),
      laySize1: parseFloat(odds[0]?.laySize1),
      laySize2: parseFloat(odds[0]?.laySize2),
      laySize3: parseFloat(odds[0]?.laySize3),
      exposure: odds[0]?.exposure,
      runnerName: odds[0]?.runnerName,
    };
    var calculationMap = {
      pandl: -Infinity,
      amount: 0,
      oddDecided: 0,
      type: "back",
      oddRate: 0,
    };
    function calculatePandL(oddType, OddSize) {
      if (oddType == "back1" || oddType == "back2" || oddType == "back3") {
        var pandlInternal =
          (oppositeTeam.exposure +
            oppositeTeam[oddType] * sameTeam.exposure -
            sameTeam.exposure) /
          oppositeTeam.oddType;
        var amountInternal = sameTeam.exposure - pandlInternal;
        if (calculationMap.pandl < pandlInternal && amountInternal > 0) {
          calculationMap.pandl = pandlInternal;
          calculationMap.amount = amountInternal;
          calculationMap.oddDecided = oppositeTeam[oddType];
          calculationMap.type = "back";
          calculationMap.oddRate = oppositeTeam[OddSize];
          calculationMap.runnerName = sameTeam.runnerName;
        }
      } else {
        var pandlInternal =
          (sameTeam.exposure +
            sameTeam[oddType] * oppositeTeam.exposure -
            oppositeTeam.exposure) /
          sameTeam[oddType];
        var amountInternal = pandlInternal - oppositeTeam.exposure;
        if (calculationMap.pandl < pandlInternal && amountInternal > 0) {
          calculationMap.pandl = pandlInternal;
          calculationMap.amount = amountInternal;
          calculationMap.oddDecided = sameTeam[oddType];
          calculationMap.type = "lay";
          calculationMap.oddRate = sameTeam[OddSize];
          calculationMap.runnerName = sameTeam.runnerName;
        }
      }
    }
    calculatePandL("back1", "backSize1");
    calculatePandL("back2", "backSize2");
    calculatePandL("back3", "backSize3");
    calculatePandL("lay1", "laySize1");
    calculatePandL("lay2", "laySize2");
    calculatePandL("lay3", "laySize3");

    if (calculationMap.pandl == -Infinity) {
      toast.error(" You are not eligible for cashout");
      return;
    }
    const cashOutPayload = {
      selectedOdd: calculationMap.oddDecided,
      selectedRate: calculationMap.oddRate,
      amount: parseFloat(calculationMap.amount).toFixed(2),
      isBookmaker: true,
      eventId: id,
      marketId: marketIdExternal,
      runnerName: calculationMap.runnerName,
      selectionId: odds[0]?.selectionId,
      marketName:
        game == "cricket"
          ? gameOdds?.matchOdds[0]?.marketName
          : gameOdds?.matchOddsResponseDTO[0]?.marketName,
      gameType:
        game == "cricket"
          ? gameOdds?.matchOdds[0]?.marketName
          : gameOdds?.matchOddsResponseDTO[0]?.marketName,
      marketType,
      sports,
      isCashout: true,
      type: calculationMap.type,
      odd: calculationMap.oddDecided,
    };

    if (cashOutPayload.type === "lay") {
      cashOutPayload.lay = cashOutPayload.odd;
    } else {
      cashOutPayload.back = cashOutPayload.odd;
    }
    cashOutPayload.profit = getProfit(
      calculationMap.amount,
      game,
      cashOutPayload
    ).profit;

    cashOutPayload.loss = getProfit(
      calculationMap.amount,
      game,
      cashOutPayload
    ).loss;

    setBetPayload(cashOutPayload);
    setSelectedEventForBet(
      {
        selectedOdd: calculationMap.oddDecided,
        selectedRate: calculationMap.oddRate,
        amount: parseFloat(calculationMap.amount).toFixed(2),
        isBookmaker: true,
        eventId: id,
        marketId: marketIdExternal,
        runnerName: calculationMap.runnerName,
        selectedId: odds[0]?.selectionId,
        marketName:
          game == "cricket"
            ? gameOdds?.matchOdds[0]?.marketName
            : gameOdds?.matchOddsResponseDTO[0]?.marketName,
        marketType,
        sports,
        isCashout: true,
        type: calculationMap.type,
      },
      true
    );
  };

  useEffect(() => {
    const layButtons = document.querySelectorAll(".market-odd-box");
    const observers = [];
    layButtons.forEach((layButton) => {
      const observer = new MutationObserver(() => {
        applyBlinkEffect(layButton);
      });
      observer.observe(layButton, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [gameOdds]);
  const handleAmountChange = (amount = DEFAULT_BET_AMOUNT) => {
    let calculation;

    if (betPayload?.isFancy) {
      let fancyPayload = {
        amount: amount,
        eventId: parseInt(betPayload.eventId),
        marketId: betPayload.marketId,
        marketName:
          betPayload.marketName != "MATCH_ODDS" ||
            betPayload.marketName != "BOOKMAKER_ODDS_1" ||
            betPayload.marketName != "BOOKMAKER_ODDS_2"
            ? betPayload.gameType
            : betPayload.marketName,
        gameType: betPayload.gameType,
      };

      if (betPayload.type === "lay") {
        fancyPayload["layRate"] = betPayload.oddSize;
        fancyPayload.oddsLay = betPayload?.odd;
        if (betPayload.gameType == "fancy1") {
          fancyPayload["layRate"] = betPayload?.odd;
          fancyPayload.oddsLay = betPayload?.odd;
        }
      } else {
        fancyPayload["backRate"] = betPayload?.oddSize;
        fancyPayload.oddsBack = betPayload?.odd;
        if (betPayload.gameType == "fancy1") {
          fancyPayload["backRate"] = betPayload?.odd;
          fancyPayload.oddsBack = betPayload?.odd;
        }
      }

      if (
        applyFancyFor.find(
          (item) => item?.toLowerCase() == betPayload?.gameType?.toLowerCase()
        )
      ) {
        if (betPayload?.type == "lay") {
          if (betPayload?.gameType == "fancy1") {
            fancyPayload.profit = cricketMatchOddsPL(
              betPayload?.odd,
              amount,
              betPayload?.type
            ).loss;
            fancyPayload.loss = cricketMatchOddsPL(
              betPayload?.odd,
              amount,
              betPayload?.type
            ).profit;
          } else {
            fancyPayload.profit = cricketFancyPL(
              betPayload?.oddSize,
              amount,
              betPayload?.type
            ).loss;
            fancyPayload.loss = cricketFancyPL(
              betPayload?.oddSize,
              amount,
              betPayload?.type
            ).profit;
          }
        } else {
          if (betPayload?.gameType == "fancy1") {
            fancyPayload.profit = cricketMatchOddsPL(
              betPayload?.odd,
              amount,
              betPayload?.type
            ).profit;
            fancyPayload.loss = cricketMatchOddsPL(
              betPayload?.odd,
              amount,
              betPayload?.type
            ).loss;
          } else {
            fancyPayload.profit = cricketFancyPL(
              betPayload?.oddSize,
              amount,
              betPayload?.type
            ).profit;
            fancyPayload.loss = cricketFancyPL(
              betPayload?.oddSize,
              amount,
              betPayload?.type
            ).loss;
          }
        }
      } else {
        fancyPayload.profit = cricketMatchOddsPL(
          betPayload?.odd,
          amount,
          betPayload?.type
        ).profit;
        fancyPayload.loss = cricketMatchOddsPL(
          betPayload?.odd,
          amount,
          betPayload?.type
        ).loss;
        fancyPayload.selectionId = betPayload.selectedId;
        fancyPayload.runnerName = betPayload.runnerName;
        if (betPayload?.type === "lay") {
          fancyPayload["layRate"] = betPayload?.odd;
        } else {
          fancyPayload["backRate"] = betPayload?.odd;
        }
      }
      setBetPayload({
        ...betPayload,
        ...fancyPayload,
      });
      return;
    } else if (betPayload?.isBookMaker) {
      calculation = cricketBookMakerPL(
        betPayload?.odd,
        amount,
        betPayload?.type
      );
    } else {
      calculation = casinoPL(betPayload?.odd, amount, betPayload?.type);
    }
    setBetPayload({
      ...betPayload,
      profit: parseFloat(calculation.profit).toFixed(2),
      loss: parseFloat(calculation.loss).toFixed(2),
      amount: amount,
    });
  };
  const handleBetPlace = async () => {
    setIsPlacingBet(true); // trigger re-render
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 3000); // 3 seconds
    // Wait a tick so React can render the button text
    await new Promise(resolve => setTimeout(resolve, 0));

    //console.log("Delay starting at:", new Date().toLocaleTimeString());
    await new Promise(resolve => setTimeout(resolve, 3000));
    //console.log("Delay ended at:", new Date().toLocaleTimeString());

    try {
      if (betPayload?.isFancy) {
        const { status, code } = await placeFancyCricketBetAPI(betPayload);
        if (code === 200) {
          setBetPayload(null);
          toast.success("Bet placed successfully");
        } else if (code === "ERR_BAD_RESPONSE") {
          toast.error("Something went wrong");
        } else {
          toast.error(status);
        }
      } else {
        const { status, code } = await placeCricketBetAPI(betPayload);
        if (code === 200) {
          setBetPayload(null);
          toast.success("Bet placed successfully");
        } else if (code === "ERR_BAD_RESPONSE") {
          toast.error("Something went wrong");
        } else {
          toast.error(status);
        }
      }
    } catch (error) {
      toast.error("An unexpected error occurred");
    } finally {
      setIsPlacingBet(false);
    }
  };

  const handleMatchOddClick = (odd, oddSize, item, isBack = true) => {
    let runnersAndExposure = [];

    handleAmountChange(DEFAULT_BET_AMOUNT);
    let calculation = casinoPL(
      odd,
      betPayload?.amount ? betPayload?.amount : DEFAULT_BET_AMOUNT,
      isBack ? "back" : "lay"
    );
    gameOdds?.matchOdds[0]?.oddDetailsDTOS.map((m) => {
      runnersAndExposure.push({
        runnerName: m.runnerName,
        exposure:
          m?.selectionId === item?.selectionId
            ? parseFloat(calculation.profit).toFixed(2)
            : "-" + parseFloat(calculation.loss).toFixed(2),
        preExposure: eventExposureAndSettings?.plExposureResponseDTOs
          ?.find(
            (i) => i.marketIdExternal === gameOdds?.matchOdds[0]?.marketId
          )
          ?.runnerPlExposureDTOS?.find(
            (runner) => runner.selectionId == m.selectionId
          )?.exposure,
      });
    });
    let payload = {
      profit: parseFloat(calculation.profit).toFixed(2),
      loss: parseFloat(calculation.loss).toFixed(2),
      marketId: gameOdds?.matchOdds[0]?.marketId,
      selectionId: item.selectionId,
      runnerName: item.runnerName,
      type: isBack ? "back" : "lay",
      eventId: id,
      marketName: gameOdds?.matchOdds[0]?.marketName,
      gameType: gameOdds?.matchOdds[0]?.marketName,
      odd: odd,
      oddSize: oddSize,
      amount: betPayload?.amount ? betPayload?.amount : DEFAULT_BET_AMOUNT,
      runnersAndExposure,
    };

    payload[isBack ? "back" : "lay"] = parseFloat(odd);
    setBetPayload(payload);
   
  };
  const handleBookMakerOddClick = (
    odd,
    oddSize,
    item,
    bm,
    isBack = true,
    isOtherMarket = false
  ) => {
    let runnersAndExposure = [];
    handleAmountChange(DEFAULT_BET_AMOUNT);
    let calculation = cricketBookMakerPL(
      odd,
      betPayload?.amount ? betPayload?.amount : DEFAULT_BET_AMOUNT,
      isBack ? "back" : "lay"
    );
    let market = isOtherMarket
      ? gameOdds?.otherMarketOdds[0]
      : gameOdds?.bookMakerOdds[0][bm];
    market?.oddDetailsDTOS.map((m) => {
      runnersAndExposure.push({
        runnerName: m.runnerName,
        exposure:
          m?.selectionId === item?.selectionId
            ? parseFloat(calculation.profit).toFixed(2)
            : "-" + parseFloat(calculation.loss).toFixed(2),
      });
    });
    let payload = {
      profit: parseFloat(calculation.profit).toFixed(2),
      loss: parseFloat(calculation.loss).toFixed(2),
      marketId: market?.marketId,
      selectionId: item.selectionId,
      runnerName: item.runnerName,
      type: isBack ? "back" : "lay",
      eventId: id,
      marketName: market?.marketName,
      gameType: market?.marketName,
      odd: odd,
      oddSize: oddSize,
      amount: betPayload?.amount ? betPayload?.amount : DEFAULT_BET_AMOUNT,
      isBookMaker: true,
      runnersAndExposure,
    };
    payload[isBack ? "back" : "lay"] = parseFloat(odd);
    setBetPayload(payload);
   
  };
  const handleFancyOddClick = (odd, oddSize, item, gameType, isBack = true) => {
    let marketData = gameOdds?.fancyOdds?.find(
      (game) => game.gameType == gameType
    );

    let calculation;
    let payload = {};
    let profit = 0;
    let loss = 0;
    if (isBack) {
      payload["backRate"] = oddSize;
      payload["oddsBack"] = odd;
      calculation = cricketFancyPL(
        oddSize,
        betPayload?.amount ? betPayload?.amount : DEFAULT_BET_AMOUNT,
        "back"
      );
      profit = parseFloat(calculation.profit);
      loss = parseFloat(calculation.loss);
    } else {
      payload["layRate"] = oddSize;
      payload["oddsLay"] = odd;
      calculation = cricketFancyPL(
        oddSize,
        betPayload?.amount ? betPayload?.amount : DEFAULT_BET_AMOUNT,
        "lay"
      );
      profit = parseFloat(calculation.loss);
      loss = parseFloat(calculation.profit);
    }
    let type = isBack ? "back" : "lay";
    let amount = 0;

    if (
      applyFancyFor.find(
        (item) => item?.toLowerCase() == gameType?.toLowerCase()
      )
    ) {
      if (type == "lay") {
        if (gameType == "fancy1") {
          profit = cricketMatchOddsPL(odd, amount, type).loss;
          loss = cricketMatchOddsPL(odd, amount, type).profit;
        } else {
          profit = cricketFancyPL(oddSize, amount, type).loss;
          loss = cricketFancyPL(oddSize, amount, type).profit;
        }
      } else {
        if (gameType == "fancy1") {
          profit = cricketMatchOddsPL(odd, amount, type).profit;
          loss = cricketMatchOddsPL(odd, amount, type).loss;
        } else {
          profit = cricketFancyPL(oddSize, amount, type).profit;
          loss = cricketFancyPL(oddSize, amount, type).loss;
        }
      }
    } else {
      profit = cricketMatchOddsPL(odd, amount, type).profit;
      loss = cricketMatchOddsPL(odd, amount, type).loss;

      if (type === "lay") {
        payload["layRate"] = odd;
      } else {
        payload["backRate"] = odd;
      }
    }

    payload = {
      ...payload,
      marketId: item?.marketId,
      selectionId: item.selectionId,
      runnerName: item.runnerName,
      type: isBack ? "back" : "lay",
      eventId: id,
      isBack: isBack,
      marketName: marketData?.marketName,
      gameType: gameType,
      odd: odd,
      oddSize: oddSize,
      amount,
      profit: parseFloat(calculation.profit).toFixed(2),
      loss: parseFloat(calculation.loss).toFixed(2),
      isFancy: true,
    };
    setBetPayload(payload);
    elementRef.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };
  useEffect(() => {
    getGameEventDetails();
    getCricketOddsByMatchId();
    getEventExposureAndSettings();
    let interval = setInterval(() => {
      getCricketOddsByMatchId();
      getEventExposureAndSettings();
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  const fetchMyBets = useCallback(async () => {
    const { response, code } = await getMyBetsCricketAPI(id);
    setUserBets(code == 200 ? response : []);
  }, [id]);
  useEffect(() => {
    fetchMyBets();
    let interval = setInterval(() => {
      fetchMyBets();
    }, 2500);
    return () => {
      clearInterval(interval);
    };
  }, []);
  const [channelId, setChannelId] = useState();
  const getLiveStreamingUrl = async () => {
    const { response } = await getLiveStreamingUrlAPI(gameEvent?.eventId);
    setChannelId(response);
  };

  useEffect(() => {
    getLiveStreamingUrl();
  }, [gameEvent?.eventId]);

  const amountFormatter = (amount, toL = true) => {
    if (amount > 10000000) {
      return amount / 10000000 + "Cr";
    } else if (amount > 100000) {
      return amount / 100000 + "L";
    } else if (amount > 1000) {
      return amount / 1000 + "K";
    } else {
      return amount;
    }
  };
  const getLadderForMarket = (marketId) => {
    return eventExposureAndSettings?.plExposureResponseDTOs?.find(
      (i) => i.marketIdExternal === marketId
    )?.runnerPlExposureDTOS;
  };
  const checkIfFloat = (value) => {
    return value % 1 != 0 ? parseFloat(value).toFixed(2) : parseInt(value);
  };
  return (
    <main>
      <div>
        <div className="container-fluid match" style={{}}>
          <div
            className="row margin0"
            style={{
              background: "rgb(10, 32, 59)",
              color: "rgb(255, 255, 255)",
              padding: 5,
            }}
          >
            <marquee>
              {" "}
              NEW AVIATOR GAME LAUNCH THIS EXCH SO TRY PLAY AND BIG WIN ENJOY
              US
            </marquee>
          </div>
          <div className="mod-header">
            <div
              className="row margin0"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <span onClick={() => setIsTvOpen(!isTvOpen)} style={{ fontWeight: "bold", paddingTop: 3, width: 50 }}>
                TV
              </span>
              <span
                className="blinktext"
                style={{ fontWeight: "bold", paddingTop: 2 }}
              >
                FS
              </span>
            </div>
          </div>
          {isTvOpen && <div className="">
            <iframe
              allowFullScreen={true}
              style={{
                width: "100%",
                height: "220px",
              }}
              // src={` https://bigpro.zapto.org/diamondoriginaltv?gmid=${gameEvent?.oldgmid}`}

              src={`https://video.proexch.in/tv/static?chid=${channelId}`}

            // src={` https://score.proexch.in/#/score1/${gameEvent?.eventId}`}  

            // https://video.247sitedata.xyz/tv/static?chid=${eventId}



            // src={`https://apis.professorji.in/api/tv?sport=cricket&eventId=${id}`}
            />
          </div>}
          <div className="videoWrapper">
            <iframe
              src={` https://score.proexch.in/#/score1/${gameEvent?.eventId}`}
              className="scoreboard-iframe"
              style={{ border: "none" }}
            />
          </div>
          <div className="scroll-form oddsTable " style={{}}>
            <table className="table-bordered" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th
                    className="bet-place-tbl-th run-pos-rate-amt-run-mod-color"
                    style={{ width: "60%" }}
                  >
                    {" "}
                    Min: 200 Max: 200000
                  </th>
                  <th
                    className="bet-place-tbl-th lagai-box-color"
                    style={{ width: "20%" }}
                  >
                    LAGAI
                  </th>
                  <th
                    className="bet-place-tbl-th khai-box-color"
                    style={{ width: "20%" }}
                  >
                    KHAI
                  </th>
                </tr>
              </thead>

              <tbody style={{ fontSize: 25 }} >

                {/* <tbody style={{ fontSize: '22px' }}> */}

                {gameOdds?.bookMakerOdds &&
                  gameOdds?.bookMakerOdds?.length > 0 &&
                  gameOdds?.bookMakerOdds[0]?.bm1?.oddDetailsDTOS?.map(
                    (item) => (
                      <>
                        <tr>
                          <td
                            className="bet-place-tbl-td"
                            style={{ textAlign: "left", padding: 1, width: "60%", }}
                          >
                            {item?.runnerName}
                            {/*    style={{
                                    fontWeight: 600,
                                    overflow: "hidden",
                                    height: 23,
                                  }} */}
                            <p
                              style={{
                                fontWeight: 600,
                                overflow: "hidden",
                                height: 23,

                                color:
                                  eventExposureAndSettings?.plExposureResponseDTOs
                                    ?.find(
                                      (i) =>
                                        i.marketIdExternal ===
                                        gameOdds?.bookMakerOdds[0]?.bm1
                                          ?.marketId
                                    )
                                    ?.runnerPlExposureDTOS?.find(
                                      (runner) =>
                                        runner.selectionId == item.selectionId
                                    )?.exposure > 0
                                    ? "rgb(81, 153, 230)"
                                    : "rgb(255, 0, 0)",
                                margin: 0,
                              }}
                            >
                              {
                                eventExposureAndSettings?.plExposureResponseDTOs
                                  ?.find(
                                    (i) =>
                                      i.marketIdExternal ===
                                      gameOdds?.bookMakerOdds[0]?.bm1?.marketId
                                  )
                                  ?.runnerPlExposureDTOS?.find(
                                    (runner) =>
                                      runner.selectionId == item.selectionId
                                  )?.exposure
                              }
                            </p>
                          </td>
                          <td
                            onClick={() =>
                              handleBookMakerOddClick(
                                item?.back1,
                                item?.backSize1,
                                item,
                                "bm1"
                              )
                            }
                            className="bet-place-tbl-td cursor-pointer "
                            style={{
                              color: "blue",
                            }}
                          >
                            <span>{item?.back1}</span>
                          </td>
                          <td
                            onClick={() =>
                              handleBookMakerOddClick(
                                item?.lay1,
                                item?.laySize1,
                                item,
                                "bm1",
                                false
                              )
                            }
                            className="bet-place-tbl-td cursor-pointer "
                            style={{ color: "red", fontWeight: 600, }}
                          >
                            <span>{item?.lay1}</span>
                          </td>
                        </tr>
                        {
                          betPayload && betPayload.selectionId == item.selectionId && <div
                            className="numeric-keypad-main-div-session d-md-none col-xs-12 col-sm-12"
                            style={{ padding: 0 }}
                          >
                           <table
  className="num-pad Input-close-table"
  style={{
    width: "100%",
    maxWidth: 400,
    margin: "0 auto",
    borderCollapse: "collapse",
    padding: 10,
  }}
>
  <tbody>
    <tr>
      <td style={{ fontSize: 14, padding: 5, border: "none", width: "30%" }}>Amount</td>
      <td style={{ border: "none", width: "40%" }}>
        <input
          list="stacklist"
          type="number"
          id="stakeInput"
          disabled={false}
          ref={elementRef}
          // value={betPayload?.amount}
          onChange={(e) => handleAmountChange(e.target.value)}
          className="quantity-session"
          style={{
            fontSize: 14,
            padding: "5px 8px",
            height: 35,
            width: 70,
            maxWidth: 150,
            color: "#000",
            boxSizing: "border-box",
            borderRadius: 5,
            border: "1px solid #ccc",
          }}
        />
        <datalist id="stacklist">
          <option value={500} />
          <option value={1000} />
          <option value={2500} />
          <option value={5000} />
          <option value={10000} />
          <option value={20000} />
          <option value={25000} />
          <option value={50000} />
          <option value={100000} />
        </datalist>
      </td>

      <td
        style={{
          border: "none",
          fontWeight: "bold",
          fontSize: 16,
          textAlign: "center",
          width: "10%",
          color: "#000",
        }}
      >
        <span>0</span>
      </td>

      <td
        style={{
          border: "none",
          width: "20%",
          textAlign: "center",
        }}
      >
        <span
          style={{
            display: "inline-block",
            padding: "2px 7px",
            position: "relative",
          }}
        >
          {!loading && (
            <button
              onClick={handleBetPlace}
              type="button"
              disabled={loading}
              style={{
                border: "none",
                background: "#767171",
                padding: "5px 10px",
                borderRadius: 5,
                color: "#fff",
                fontSize: 13,
                fontWeight: "bold",
                width: 70,
                height: 35,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              DONE
            </button>
          )}

          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                zIndex: 9999,
                overflow: "hidden",
                touchAction: "none",
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  border: "4px solid #f3f3f3",
                  borderTop: "4px solid #3498db",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}
              />
              <style>
                {`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}
              </style>
            </div>
          )}
        </span>
      </td>
    </tr>
  </tbody>
</table>


                          </div>
                        }
                      </>
                    )
                  )}
              </tbody>
            </table>
          </div>
          {/* <div className="scroll-form oddsTable" style={{}}>
            <table className="table-bordered" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th
                    className="bet-place-tbl-th run-pos-rate-amt-run-mod-color"
                    style={{ width: "60%" }}
                  >
                    {" "}
                    Min: 200 Max: 200000
                  </th>
                  <th
                    className="bet-place-tbl-th lagai-box-color"
                    style={{ width: "20%" }}
                  >
                    LAGAI
                  </th>
                  <th
                    className="bet-place-tbl-th khai-box-color"
                    style={{ width: "20%" }}
                  >
                    KHAI
                  </th>
                </tr>
              </thead>
              <tbody>
                {gameOdds?.matchOdds &&
                  gameOdds?.matchOdds?.length > 0 &&
                  gameOdds?.matchOdds[0]?.oddDetailsDTOS?.map((item) => (
                    <tr>
                      <td
                        className="bet-place-tbl-td"
                        style={{ textAlign: "left", padding: 1 }}
                      >
                        {item?.runnerName}
                        <p
                          style={{
                            color:
                              eventExposureAndSettings?.plExposureResponseDTOs
                                ?.find(
                                  (i) =>
                                    i.marketIdExternal ===
                                    gameOdds?.matchOdds[0]?.marketId
                                )
                                ?.runnerPlExposureDTOS?.find(
                                  (runner) =>
                                    runner.selectionId == item.selectionId
                                )?.exposure > 0
                                ? "rgb(81, 153, 230)"
                                : "rgb(255, 0, 0)",
                            margin: 0,
                          }}
                        >
                          {
                            eventExposureAndSettings?.plExposureResponseDTOs
                              ?.find(
                                (i) =>
                                  i.marketIdExternal ===
                                  gameOdds?.matchOdds[0]?.marketId
                              )
                              ?.runnerPlExposureDTOS?.find(
                                (runner) =>
                                  runner.selectionId == item.selectionId
                              )?.exposure
                          }
                        </p>
                      </td>
                      <td
                        onClick={() =>
                          handleMatchOddClick(
                            item?.back1,
                            item?.backSize1,
                            item,
                            true
                          )
                        }
                        className="bet-place-tbl-td cursor-pointer "
                        style={{
                          color: "blue",
                        }}
                      >
                        <span>{item?.back1}</span>
                      </td>
                      <td
                        onClick={() =>
                          handleMatchOddClick(
                            item?.lay1,
                            item?.laySize1,
                            item,
                            false
                          )
                        }
                        className="bet-place-tbl-td cursor-pointer "
                        style={{ color: "red" }}
                      >
                        <span>{item?.lay1}</span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div> */}

          {gameOdds?.fancyOdds &&
            gameOdds?.fancyOdds.length > 0 &&
            gameOdds?.fancyOdds
              ?.sort((a, b) => {
                if (a.gameType.toLowerCase() == "normal") {
                  return -1;
                }
                return 1;
              })
              ?.map((fancy) => (
                <>
                  <div className="scroll-form">
                    <table className="table-bordered" style={{ width: "100%" }}>
                      <thead className="sessions-thead">
                        <tr className="sessions-header">
                          <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color sess_row_head1">
                            {fancy?.gameType}{" "}
                            <a title="Rules" href="/tc">
                              <span
                                style={{
                                  float: "right",
                                  background: "rgb(255, 255, 255)",
                                  borderRadius: 15,
                                  padding: "0px 6px",
                                  color: "rgb(255, 0, 0)",
                                }}
                              >
                                𝓲
                              </span>
                            </a>
                          </th>
                          <th
                            className="bet-place-tbl-th not-box-color"
                            style={{ width: "22%" }}
                          >
                            NOT
                          </th>
                          <th
                            className="bet-place-tbl-th yes-box-color"
                            style={{ width: "23%" }}
                          >
                            YES
                          </th>
                        </tr>
                      </thead>
                      <tbody >
                        {fancy?.oddDetailsDTOS
                          ?.sort((a, b) => {
                            const bandA = a.runnerName;
                            const bandB = b.runnerName;

                            let comparison = 0;
                            if (bandA > bandB) {
                              comparison = 1;
                            } else if (bandA < bandB) {
                              comparison = -1;
                            }
                            return comparison;
                          })
                          ?.map((item, index) => (
                            <>

                              <tr>
                                <td
                                  className="bet-place-tbl-td"
                                  // style={{ textAlign: "left", width: "60%" }}
                                  style={{ textAlign: "left", padding: 1, width: "60%" }}
                                >
                                  <div>
                                    <div
                                      style={{
                                        fontWeight: 600,
                                        overflow: "hidden",
                                        height: 52,
                                      }}
                                    >
                                      {item?.runnerName}
                                    </div>
                                    <div style={{ fontSize: 10 }}>
                                      Session Limit : 50000
                                    </div>
                                  </div>
                                </td>
                                <td
                                  onClick={() =>
                                    handleFancyOddClick(
                                      item?.lay1,
                                      item?.laySize1,
                                      item,
                                      fancy?.gameType,
                                      false
                                    )
                                  }
                                  className="first-runner-bet-odds-no-value cursor-pointer"
                                  style={{
                                    fontWeight: 600,
                                  }}
                                >
                                  <span>{item?.lay1}</span>
                                  <div style={{ fontSize: 10 }}>
                                    {item?.laySize1}
                                  </div>
                                </td>
                                <td
                                  onClick={() =>
                                    handleFancyOddClick(
                                      item?.back1,
                                      item?.backSize1,
                                      item,
                                      fancy?.gameType,
                                      true
                                    )
                                  }
                                  className="first-runner-bet-odds-yes-value cursor-pointer"
                                  style={{
                                    fontWeight: 600,
                                  }}
                                >
                                  <span>{item?.back1}</span>
                                  <div style={{ fontSize: 10 }}>
                                    {item?.backSize1}
                                  </div>
                                </td>
                              </tr>
                              {
                                betPayload && betPayload.selectionId == item.selectionId && <div
                                  className="numeric-keypad-main-div-session d-md-none col-xs-12 col-sm-12"
                                  style={{ padding: 0 }}
                                >
                                  {/* <table className="num-pad Input-close-table">
                                    <tbody>
                                      <tr style={{ padding: "5px 0px" }}>
                                        <td style={{ fontSize: 14, padding: 5, border: "none" }}>
                                          {" "}
                                          Amount{" "}
                                        </td>
                                        <td id="pppp" style={{ border: "none" }}>
                                          <input
                                            list="stacklist"
                                            type="number"
                                            id="stakeInput"
                                            disabled=""
                                            ref={elementRef}
                                            value={betPayload?.amount}
                                            onChange={(e) => handleAmountChange(e.target.value)}
                                            className="quantity-session"
                                            style={{
                                              fontSize: 14,
                                              padding: 5,
                                              height: 25,
                                              width: 150,
                                              color: "rgb(0, 0, 0)",
                                            }}
                                          />
                                          <datalist id="stacklist">
                                            <option value={500} />
                                            <option value={1000} />
                                            <option value={2500} />
                                            <option value={5000} />
                                            <option value={10000} />
                                            <option value={20000} />
                                            <option value={25000} />
                                            <option value={50000} />
                                            <option value={100000} />
                                          </datalist>
                                        </td>
                                        <td
                                          className="cls-td text-white"
                                          style={{
                                            border: "none",
                                            fontWeight: "bold",
                                            fontSize: 16,
                                            textAlign: "center",
                                            width: "10%",
                                          }}
                                        >
                                          <span>0 </span>
                                        </td>
                                        <td
                                          className="numpad-done-button cls-td"
                                          style={{ border: "none", width: "20%" }}
                                        >
                                          <span style={{ padding: "2px 7px" }}>
                                            <button
                                              onClick={handleBetPlace}
                                              type="button"
                                              disabled=""
                                              style={{
                                                border: "none",
                                                background: "rgb(118, 113, 113)",
                                                padding: 7,
                                                borderRadius: 5,
                                                color: "rgb(255, 255, 255)",
                                                fontSize: 13,
                                                fontWeight: "bold",
                                                width: 60,
                                                height: 35,
                                              }}
                                            >
                                              DONE
                                            </button>
                                          </span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table> */}
                                  {/* <table className="num-pad Input-close-table">
                                    <tbody>
                                      <tr style={{ padding: "5px 0px" }}>
                                        <td style={{ fontSize: 14, padding: 5, border: "none" }}> Amount </td>
                                        <td id="pppp" style={{ border: "none" }}>
                                          <input
                                            list="stacklist"
                                            type="number"
                                            id="stakeInput"
                                            disabled={false} // remove disabled="" to properly control it, adjust as needed
                                            ref={elementRef}
                                            value={betPayload?.amount}
                                            onChange={(e) => handleAmountChange(e.target.value)}
                                            className="quantity-session"
                                            style={{
                                              fontSize: 14,
                                              padding: 5,
                                              height: 25,
                                              width: 150,
                                              color: "rgb(0, 0, 0)",
                                            }}
                                          />
                                          <datalist id="stacklist">
                                            <option value={500} />
                                            <option value={1000} />
                                            <option value={2500} />
                                            <option value={5000} />
                                            <option value={10000} />
                                            <option value={20000} />
                                            <option value={25000} />
                                            <option value={50000} />
                                            <option value={100000} />
                                          </datalist>
                                        </td>
                                        <td
                                          className="cls-td text-white"
                                          style={{
                                            border: "none",
                                            fontWeight: "bold",
                                            fontSize: 16,
                                            textAlign: "center",
                                            width: "10%",
                                          }}
                                        >
                                          <span>0 </span>
                                        </td>
                                        <td
                                          className="numpad-done-button cls-td"
                                          style={{ border: "none", width: "20%" }}
                                        >
                                          <span style={{ padding: "2px 7px", position: "relative", display: "inline-block" }}>
                                            {!loading && (
                                              <button
                                                onClick={handleBetPlace}
                                                type="button"
                                                disabled={loading}
                                                style={{
                                                  border: "none",
                                                  background: "rgb(118, 113, 113)",
                                                  padding: 7,
                                                  borderRadius: 5,
                                                  color: "rgb(255, 255, 255)",
                                                  fontSize: 13,
                                                  fontWeight: "bold",
                                                  width: 60,
                                                  height: 35,
                                                  cursor: loading ? "not-allowed" : "pointer",
                                                }}
                                              >
                                                DONE
                                              </button>
                                            )}

                                            {loading && (
                                              <div
                                                style={{
                                                  position: "fixed",
                                                  top: 0,
                                                  left: 0,
                                                  width: "100%",
                                                  height: "100%",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                                                  zIndex: 9999,
                                                  overflow: "hidden",
                                                  touchAction: "none", // prevent scrolling/touch behind overlay
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    width: 40,
                                                    height: 40,
                                                    border: "4px solid #f3f3f3",
                                                    borderTop: "4px solid #3498db",
                                                    borderRadius: "50%",
                                                    animation: "spin 1s linear infinite",
                                                    background: "transparent",
                                                  }}
                                                ></div>

                                                <style>
                                                  {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
                                                </style>
                                              </div>
                                            )}
                                          </span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table> */}
                                  <table
  className="num-pad Input-close-table"
  style={{
    width: "100%",
    maxWidth: 400,
    margin: "0 auto",
    borderCollapse: "collapse",
    padding: 10,
  }}
>
  <tbody>
    <tr>
      <td style={{ fontSize: 14, padding: 5, border: "none", width: "30%" }}>Amount</td>
      <td style={{ border: "none", width: "40%" }}>
        <input
          list="stacklist"
          type="number"
          id="stakeInput"
          disabled={false}
          ref={elementRef}
          //va
          onChange={(e) => handleAmountChange(e.target.value)}
          className="quantity-session"
          style={{
            fontSize: 14,
            padding: "5px 8px",
            height: 35,
            width: 80,
            maxWidth: 150,
            color: "#000",
            boxSizing: "border-box",
            borderRadius: 5,
            border: "1px solid #ccc",
          }}
        />
        <datalist id="stacklist">
          <option value={500} />
          <option value={1000} />
          <option value={2500} />
          <option value={5000} />
          <option value={10000} />
          <option value={20000} />
          <option value={25000} />
          <option value={50000} />
          <option value={100000} />
        </datalist>
      </td>

      <td
        style={{
          border: "none",
          fontWeight: "bold",
          fontSize: 16,
          textAlign: "center",
          width: "10%",
          color: "#000",
        }}
      >
        <span>0</span>
      </td>

      <td
        style={{
          border: "none",
          width: "20%",
          textAlign: "center",
        }}
      >
        <span
          style={{
            display: "inline-block",
            padding: "2px 7px",
            position: "relative",
          }}
        >
          {!loading && (
            <button
              onClick={handleBetPlace}
              type="button"
              disabled={loading}
              style={{
                border: "none",
                background: "#767171",
                padding: "5px 10px",
                borderRadius: 5,
                color: "#fff",
                fontSize: 13,
                fontWeight: "bold",
                width: 70,
                height: 35,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              DONE
            </button>
          )}

          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                zIndex: 9999,
                overflow: "hidden",
                touchAction: "none",
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  border: "4px solid #f3f3f3",
                  borderTop: "4px solid #3498db",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}
              />
              <style>
                {`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}
              </style>
            </div>
          )}
        </span>
      </td>
    </tr>
  </tbody>
</table>

                                </div>
                              }
                            </>
                          ))}
                      </tbody>
                    </table>
                  </div>

                </>

              ))}
          <div className="d-sm-none">
            <div className="row" style={{ fontSize: 18 }}>
              <div className="col-md-3 col-lg-3">
                <div>
                  <span
                    style={{ fontWeight: "bold", textTransform: "uppercase" }}
                  >
                    &nbsp;:&nbsp;
                  </span>
                </div>
              </div>
              <div className="col-md-3 col-lg-3">
                <div>
                  <b>RATE:</b>
                  {betPayload?.odd} { }
                </div>
              </div>
              <div className="col-xs-0 col-sm-0 col-md-6 col-lg-6">
                <form id="pppp" className="form-inline">
                  <label htmlFor="email">AMOUNT</label>
                  <input
                    type="text"
                    id="stakeInput"
                    placeholder="stake"
                    ref={elementRef}
                    style={{ fontSize: 18 }}
                    value={betPayload?.amount}
                    onChange={(e) => handleAmountChange(e.target.value)}
                  />
                  {/* <button
                    onClick={handleBetPlace}
                    type="button"
                    className="btn bet_btn"
                  >
                    {" "}
                    Done
                  </button> */}
                  <button
                    onClick={handleBetPlace}
                    type="button"
                    className="btn bet_btn"
                    disabled={isPlacingBet}
                  >
                    {isPlacingBet ? "Placing..." : "Done"}
                  </button>
                </form>
                <div className="place-amount load-button-new-className enter-default-value place-bet-buttons-div">
                  <table className="bet-value-buttons-table">
                    <tbody>
                      <tr>
                        <td>
                          <button className="default-value-btn">1H</button>
                        </td>
                        <td>
                          <button className="default-value-btn">5H</button>
                        </td>
                        <td>
                          <button className="default-value-btn">10H</button>
                        </td>
                        <td>
                          <button className="default-value-btn">25H</button>
                        </td>
                        <td>
                          <button className="default-value-btn">50H</button>
                        </td>
                        <td>
                          <button className="default-value-btn bet-value-clear-button">
                            Clear
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <button className="default-value-btn">1L</button>
                        </td>
                        <td>
                          <button className="default-value-btn">2L</button>
                        </td>
                        <td>
                          <button className="default-value-btn">5L</button>
                        </td>
                        <td>
                          <button className="default-value-btn">10L</button>
                        </td>
                        <td>
                          <button className="default-value-btn">25L</button>
                        </td>
                        <td>
                          <button className="default-value-btn bet-value-clear-button">
                            0
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {/* <div
            className="numeric-keypad-main-div-session d-md-none col-xs-12 col-sm-12"
            style={{ padding: 0 }}
          >
            <table className="num-pad Input-close-table">
              <tbody>
                <tr style={{ padding: "5px 0px" }}>
                  <td style={{ fontSize: 14, padding: 5, border: "none" }}>
                    {" "}
                    Amount{" "}
                  </td>
                  <td id="pppp" style={{ border: "none" }}>
                    <input
                      list="stacklist"
                      type="number"
                      id="stakeInput"
                      disabled=""
                      ref={elementRef}
                      value={betPayload?.amount}
                      onChange={(e) => handleAmountChange(e.target.value)}
                      className="quantity-session"
                      style={{
                        fontSize: 14,
                        padding: 5,
                        height: 25,
                        width: 150,
                        color: "rgb(0, 0, 0)",
                      }}
                    />
                    <datalist id="stacklist">
                      <option value={500} />
                      <option value={1000} />
                      <option value={2500} />
                      <option value={5000} />
                      <option value={10000} />
                      <option value={20000} />
                      <option value={25000} />
                      <option value={50000} />
                      <option value={100000} />
                    </datalist>
                  </td>
                  <td
                    className="cls-td text-white"
                    style={{
                      border: "none",
                      fontWeight: "bold",
                      fontSize: 16,
                      textAlign: "center",
                      width: "10%",
                    }}
                  >
                    <span>0 </span>
                  </td>
                  <td
                    className="numpad-done-button cls-td"
                    style={{ border: "none", width: "20%" }}
                  >
                    <span style={{ padding: "2px 7px" }}>
                      <button
                        onClick={handleBetPlace}
                        type="button"
                        disabled=""
                        style={{
                          border: "none",
                          background: "rgb(118, 113, 113)",
                          padding: 7,
                          borderRadius: 5,
                          color: "rgb(255, 255, 255)",
                          fontSize: 13,
                          fontWeight: "bold",
                          width: 60,
                          height: 35,
                        }}
                      >
                        DONE
                      </button>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> */}
          <div>
            <table className="table-bordered" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th
                    colSpan={5}
                    className="bet-place-tbl-th market-name-row-color"
                    style={{ background: "rgb(42, 54, 59)" }}
                  >
                    MATCH ODDS
                  </th>
                </tr>
                <tr>
                  <th className="bet-place-tbl-th mob-col-width-ch run-pos-rate-amt-run-mod-color sess_row_head1">
                    SESSION
                  </th>
                  <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color">
                    RUN
                  </th>
                  <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color">
                    RATE
                  </th>
                  <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color">
                    AMOUNT
                  </th>
                  <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color">
                    MODE
                  </th>
                </tr>
              </thead>
              <tbody>
                {userBets
                  ?.filter((item) => item?.marketName != "FANCY_ODDS")
                  ?.map((bet) => (
                    <tr>
                      <td
                        className="bet-place-tbl-td mob-col-width-ch runs-2-value-box-color"
                        style={{ textAlign: "left" }}
                      >
                        {bet?.runnerName}
                      </td>
                      <td
                        data-modal="modal-1"
                        className="bet-place-tbl-td md-trigger runs-2-value-box-color"
                      >
                        {bet?.back ? bet?.back : bet?.lay}
                      </td>
                      <td
                        data-modal="modal-1"
                        className="bet-place-tbl-td md-trigger runs-2-value-box-color"
                      >
                        {bet?.back ? bet?.back : bet?.lay}
                      </td>
                      <td className="bet-place-tbl-td runs-2-value-box-color">
                        {bet?.amount}
                      </td>
                      <td className="bet-place-tbl-td runs-2-value-box-color">
                        {bet?.back ? "LAGAI" : "KHAI"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div>
            <table className="table-bordered" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th
                    colSpan={5}
                    className="bet-place-tbl-th market-name-row-color"
                    style={{ background: "rgb(42, 54, 59)" }}
                  >
                    FANCY BETS
                  </th>
                </tr>
                <tr>
                  <th className="bet-place-tbl-th mob-col-width-ch run-pos-rate-amt-run-mod-color sess_row_head1">
                    SESSION
                  </th>
                  <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color">
                    RUN
                  </th>
                  <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color">
                    RATE
                  </th>
                  <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color">
                    AMOUNT
                  </th>
                  <th className="bet-place-tbl-th run-pos-rate-amt-run-mod-color">
                    MODE
                  </th>
                </tr>
              </thead>
              <tbody>
                {userBets
                  ?.filter((item) => item?.marketName == "FANCY_ODDS")
                  ?.map((bet) => (
                    <tr>
                      <td
                        className="bet-place-tbl-td mob-col-width-ch runs-2-value-box-color"
                        style={{ textAlign: "left" }}
                      >
                        {bet?.runnerName}
                      </td>
                      <td
                        data-modal="modal-1"
                        className="bet-place-tbl-td md-trigger runs-2-value-box-color"
                      >
                        {bet?.back ? bet?.back : bet?.lay}
                      </td>
                      <td
                        data-modal="modal-1"
                        className="bet-place-tbl-td md-trigger runs-2-value-box-color"
                      >
                        {/* {bet?.back ? bet?.back : bet?.lay} */}
                        {userData?.liability}
                        
                      </td>
                      <td className="bet-place-tbl-td runs-2-value-box-color">
                        {bet?.amount}
                      </td>
                      <td className="bet-place-tbl-td runs-2-value-box-color">
                        {bet?.back ? "YES" : "NOT"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {cricketMatches?.map((item) => (
            <div>
              <a onClick={() => navigateToGame(item)}>
                <div
                  className="row"
                  style={{
                    paddingBottom: 3,
                    paddingTop: 3,
                    borderBottom: "1px solid blue",
                  }}
                >
                  <div className="col-xs-12 col-md-12">
                    <h3
                      className="oflow"
                      style={{ fontSize: 15, color: "rgb(40, 116, 181)" }}
                    >
                      <div className="blinking-green" />
                      {item?.eventName}
                    </h3>
                  </div>
                  <div
                    className="col-xs-6 col-md-2"
                    style={{
                      fontWeight: 800,
                      fontSize: 13,
                      color: "rgb(95, 101, 99)",
                    }}
                  >
                    {moment(item?.eventDate).format("DD-MM-YY hh:mm A")}
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}